import { apiRequest } from "./client";

function query(params = {}) {
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value !== "" && value !== null && value !== undefined) search.set(key, String(value));
  }
  return search.size ? `?${search}` : "";
}

// # SELLERS: una sola sesión y el cliente HTTP existente. Sin credenciales paralelas.
export const sellersApi = {
  profile: () => apiRequest("/seller/profile"),
  summary: () => apiRequest("/seller/summary"),
  commissions: (params) => apiRequest(`/seller/commissions${query(params)}`),
  prospects: (params) => apiRequest(`/seller/prospects${query(params)}`),
  createProspect: (body) => apiRequest("/seller/prospects", { method: "POST", body: JSON.stringify(body) }),
  updateProspect: (id, body) => apiRequest(`/seller/prospects/${encodeURIComponent(id)}`, { method: "PATCH", body: JSON.stringify(body) }),
  updateAccess: (id, body) => apiRequest(`/users/${encodeURIComponent(id)}/seller`, { method: "PATCH", body: JSON.stringify(body) }),
};
